import type { CurrencyCode, ScanResult } from '../../types';
import { MOCK_SCANS } from '../../lib/mockData';
import { makeId, request } from '../api/client';

export interface QrPayload {
  recipientId?: string;
  amount?: number;
  currency?: CurrencyCode;
  note?: string;
}

export const qrService = {
  /** Build a deterministic 21x21 boolean matrix from a string (fake but stable QR). */
  generateMatrix(data: string, size = 25): boolean[][] {
    let hash = 2166136261;
    const matrix: boolean[][] = [];
    for (let y = 0; y < size; y++) {
      const row: boolean[] = [];
      for (let x = 0; x < size; x++) {
        hash ^= data.charCodeAt((x * 31 + y * 17 + data.length) % data.length);
        hash = Math.imul(hash, 16777619);
        row.push(((hash >>> ((x + y) % 16)) & 1) === 1);
      }
      matrix.push(row);
    }
    return matrix;
  },

  encode(payload: QrPayload) {
    return request('/qr/encode', () => `peskedo://pay?${new URLSearchParams(
      Object.entries(payload).reduce((acc, [k, v]) => {
        if (v !== undefined) acc[k] = String(v);
        return acc;
      }, {} as Record<string, string>),
    ).toString()}`, { delay: 150 });
  },

  /** Simulate decoding a scanned code. */
  decode() {
    return request('/qr/decode', () => {
      const result: ScanResult = {
        id: makeId('s'),
        type: 'qr',
        payload: 'peskedo://pay/merchant/blue-bottle',
        merchant: 'Blue Bottle Coffee',
        amount: Math.round((Math.random() * 40 + 5) * 100) / 100,
        currency: 'USD',
        scannedAt: new Date().toISOString(),
      };
      return result;
    }, { delay: 1800 });
  },

  history() {
    return request('/qr/history', () => MOCK_SCANS);
  },
};
